var _excluded = ["title", "content", "isOpen", "onClick", "isDarkMode"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React, { useState } from "react";
import { padding } from "polished";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
var IconArrowSvg = function IconArrowSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    className: "wrapper",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon",
    clipRule: "evenodd",
    d: "M6.246 10.216a.675.675 0 0 0 0 1.042l5.16 4.526c.164.144.379.216.594.216a.9.9 0 0 0 .594-.216l5.16-4.526a.675.675 0 0 0 0-1.042.926.926 0 0 0-1.189 0L12 14.221l-4.565-4.005a.926.926 0 0 0-1.189 0Zm10.848.29Z"
  }));
};
IconArrowSvg.defaultProps = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { KeyboardEventKeys } from "../../../typings/types";
import breakpoint from "../../../utils/breakpoint";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import getIconColor from "../../../utils/getIconColor";
import space, { spaceFactor } from "../../../utils/space";
import transition from "../../../utils/transition";
import unit from "../../../utils/unit";
import TextAtm from "../../atoms/TextAtm";
import AnimateHeightOrg from "../../organisms/AnimateHeightOrg";
var breakpointValue = "medium";
var backgroundColor = "backgroundLight";
var backgroundColorDarkMode = "backgroundDark";
var paddingVerticalSpaceSmall = 2.5;
var paddingHorizontalSpaceSmall = 2;
var paddingVerticalSpaceMedium = 3;
var paddingHorizontalSpaceMedium = 3;
var iconBackgroundColor = "backgroundDarkLight";
var iconSizeSpace = 3;
var titleTypography = "medium3_s";
var Wrapper = styled.div.withConfig({
  componentId: "sc-1bfugnh-0"
})(function (_ref) {
  var $isDarkMode = _ref.$isDarkMode,
    theme = _ref.theme;
  return css(["", ";display:flex;border-radius:", ";background-color:", ";box-shadow:", ";cursor:pointer;", "{", ";}"], padding.apply(void 0, _toConsumableArray(space(paddingVerticalSpaceSmall, paddingHorizontalSpaceSmall))), getBorderRadius(theme, "small"), getColor(theme, $isDarkMode ? backgroundColorDarkMode : backgroundColor), getBoxShadow(theme, "small"), breakpoint(breakpointValue), padding.apply(void 0, _toConsumableArray(space(paddingVerticalSpaceMedium, paddingHorizontalSpaceMedium))));
});
var IconArrow = styled(IconArrowSvg).withConfig({
  componentId: "sc-1bfugnh-1"
})(function (_ref2) {
  var $isOpen = _ref2.$isOpen,
    $isDarkMode = _ref2.$isDarkMode,
    theme = _ref2.theme;
  return css(["", ";flex-shrink:0;margin-right:", ";", "{margin-right:", ";}.wrapper{fill:", ";}.icon{", ";fill:", ";}", ""], transition("transform"), space(paddingHorizontalSpaceSmall), breakpoint(breakpointValue), space(paddingHorizontalSpaceMedium), getColor(theme, iconBackgroundColor), transition("fill"), getIconColor(theme, iconBackgroundColor, $isDarkMode ? "high" : "low"), $isOpen && css(["transform:rotate(-180deg);.icon{fill:", ";}"], getIconColor(theme, iconBackgroundColor, "high")));
});
var Content = styled.div.withConfig({
  componentId: "sc-1bfugnh-2"
})(function (_ref3) {
  var theme = _ref3.theme;
  return css(["padding-top:", ";", "{max-width:", ";}"], unit((iconSizeSpace - theme.typography[titleTypography].lineHeightSpace) * spaceFactor / 2), breakpoint("large"), space(128));
});
var TextWrapper = styled(AnimateHeightOrg).withConfig({
  componentId: "sc-1bfugnh-3"
})(["> *{padding-top:", ";", "{padding-top:", ";}}"], space(2.5), breakpoint(breakpointValue), space(3));
function FaqMol(_ref4) {
  var title = _ref4.title,
    content = _ref4.content,
    isOpen = _ref4.isOpen,
    onClick = _ref4.onClick,
    isDarkMode = _ref4.isDarkMode,
    restProps = _objectWithoutProperties(_ref4, _excluded);
  var _useState = useState(!!isOpen),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenValue = _useState2[0],
    setIsOpen = _useState2[1];
  var handleOnClick = function handleOnClick(open) {
    setIsOpen(function (value) {
      return open !== null && open !== void 0 ? open : !value;
    });
    if (onClick) {
      onClick(open !== null && open !== void 0 ? open : isOpenValue);
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === KeyboardEventKeys.ENTER || event.key === KeyboardEventKeys.SPACE) {
      event.preventDefault();
      handleOnClick();
    }
    if (event.key === KeyboardEventKeys.ESC) {
      event.preventDefault();
      handleOnClick(false);
    }
  };
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    onClick: function onClick() {
      return handleOnClick();
    },
    onKeyDown: handleKeyDown,
    $isDarkMode: !!isDarkMode,
    tabIndex: 0
  }, restProps), /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: isDarkMode ? backgroundColorDarkMode : backgroundColor
  }, /*#__PURE__*/React.createElement(IconArrow, {
    $isOpen: isOpenValue,
    $isDarkMode: !!isDarkMode
  }), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(TextAtm, {
    htmlTag: "h3",
    typography: titleTypography
  }, title), /*#__PURE__*/React.createElement(TextWrapper, {
    isOpen: isOpenValue
  }, content))));
}
export default FaqMol;